import React, { useEffect, useRef, useState } from "react";
import ModalComponent from "../../../../components/Modals/modal";
import { useDispatch, useSelector } from "react-redux";
import {
  debitFarmers,
  getFarmersProfile,
} from "../../../../redux/Farmers/farmersActions";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { useOutsideAlerter } from "../../../../helpers/OutsideClick";
import { getAllDebitActions } from "../../../../redux/Location/locationAction";

const DebitSingleFarmerModal = ({ id, phoneNumber }) => {
  const [isShow, setShow] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [amount, setAmount] = useState("");
  const [toggleIcon, setToggleIcon] = useState(false);
  const [selectedAction, setSelectedAction] = useState("");
  const dispatch = useDispatch();
  const { debitActionsData } = useSelector((state) => state.location);
  const { farmersProfileData } = useSelector((state) => state.farmer);
  const { debitFarmerLoading } = useSelector((state) => state.farmer);

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, setToggleIcon);

  const handleDebit = () => {
    const values = {
      farmer_phone_number: phoneNumber,
      debit_amount: Number(amount),
      action: selectedAction,
    };

    dispatch(debitFarmers(values)).then((res) => {
      if (res.type === "debitFarmers/fulfilled") {
        setShowConfirm(false);
        setShow(false);
        setAmount("");
        setSelectedAction("");
        // Refresh farmer profile to get updated balance
        dispatch(getFarmersProfile({ id: id }));
      }
    });
  };

  useEffect(() => {
    if (isShow) {
      dispatch(getAllDebitActions());
    }
  }, [dispatch, isShow]);

  return (
    <div>
      <button
        className="py-[12px] px-[16px] text-sm font-medium leading-5 text-[#344335] cursor-pointer"
        onClick={() => {
          setShow(true);
        }}
      >
        Debit Farmer
      </button>

      {/* DEBIT FARMER MODAL */}
      <ModalComponent
        title="Debit Farmer"
        show={isShow}
        showModal={() => {
          setShow(false);
        }}
      >
        <div className="mt-6 w-full">
          <div>
            {/* FARMER INFO DISPLAY */}
            <div className="mb-5 p-4 bg-[#F7F7F7] rounded-lg">
              <p className="font-medium text-sm leading-5 text-[#344335]">
                {farmersProfileData?.first_name} {farmersProfileData?.last_name}
              </p>
              <p className="pt-1 font-medium text-xs leading-[16px] text-[#5C715E]">
                Phone: {phoneNumber}
              </p>
              <p className="pt-1 font-medium text-xs leading-[16px] text-[#5C715E]">
                Available Wallet Balance:{" "}
                <span className="text-primary">
                  ₦
                  {farmersProfileData?.available_wallet_balance?.toLocaleString() ||
                    0}
                </span>
              </p>
            </div>

            {/* DEBIT AMOUNT */}
            <div className="mb-5">
              <p className="font-[400] text-sm leading-[18px] text-[#344335]">
                Debit Amount(₦)
              </p>
              <input
                type="number"
                className="outline-none border bg-white text-[#344335] border-[#96A397] rounded-[8px] font-medium text-sm leading-5 placeholder:text-[#96A397] py-[12px] px-[16px] mt-1 w-full"
                placeholder="Debit Amount"
                onChange={(event) => setAmount(event.target.value)}
                value={amount}
              />
            </div>

            {/* ACTION DROPDOWN */}
            <div className="mb-5">
              <p className="font-[400] text-sm leading-[18px] text-[#344335]">
                Action
              </p>
              <div className="relative">
                <div
                  className="flex items-center cursor-pointer justify-between outline-0 h-[44px] bg-white rounded-[8px] border border-[#96A397] mt-[4px] px-[14px] w-full font-medium text-sm leading-5 text-[#96A397] mb-[10px]"
                  onClick={() => setToggleIcon(!toggleIcon)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      setToggleIcon(!toggleIcon);
                    }
                  }}
                >
                  <p>{selectedAction || "Select an action"}</p>

                  {toggleIcon ? (
                    <ExpandLess
                      className="text-[#ABB6AC] cursor-pointer"
                      style={{ fontSize: "18px" }}
                    />
                  ) : (
                    <ExpandMore
                      className="text-[#ABB6AC] cursor-pointer"
                      style={{ fontSize: "18px" }}
                    />
                  )}
                </div>

                {toggleIcon && (
                  <div
                    className="absolute top-full left-0 right-0 mb-4 rounded-[8px] p-[8px] w-full bg-white z-20 max-h-[250px] overflow-y-scroll"
                    ref={wrapperRef}
                    style={{
                      boxShadow:
                        "0px 0px 1px rgba(0, 0, 0, 0.25), 0px 16px 32px rgba(0, 0, 0, 0.08)",
                    }}
                  >
                    {debitActionsData?.map((data, index) => {
                      return (
                        <div
                          key={index}
                          className="px-[16px] py-[12px] hover:bg-[#EDF7EE] cursor-pointer flex gap-4"
                          onClick={() => {
                            setSelectedAction(data);
                            setToggleIcon(false);
                          }}
                          role="button"
                          tabIndex={0}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              setSelectedAction(data);
                              setToggleIcon(false);
                            }
                          }}
                        >
                          <p className="font-medium text-sm leading-5 text-[#344335] capitalize">
                            {data}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>

            {/* SUBMIT BUTTON */}
            <div className="flex justify-end items-end pt-4 pb-4">
              <button
                disabled={
                  !amount ||
                  amount === "" ||
                  amount === "0" ||
                  selectedAction === ""
                }
                type="submit"
                onClick={() => {
                  setShowConfirm(true);
                  setShow(false);
                }}
                className="bg-[#B92043] 
                    disabled:bg-[#B92043] disabled:bg-opacity-[0.7] w-fit
                    rounded-lg px-6 py-3 text-[#FEF0EC] text-sm font-medium hover:bg-opacity-[0.9] transition-all"
              >
                Debit Farmer
              </button>
            </div>
          </div>
        </div>
      </ModalComponent>

      {/* CONFIRMATION MODAL */}
      <ModalComponent
        show={showConfirm}
        showModal={() => {
          setShowConfirm(false);
          setShow(true);
        }}
        title="Debit Farmer"
        subtitle={`Are you sure you want to debit farmer ${farmersProfileData.first_name} ${farmersProfileData.last_name}`}
      >
        <div className="flex justify-end mt-8 mb-3 gap-3">
          <button
            disabled={debitFarmerLoading}
            type="submit"
            onClick={handleDebit}
            className="bg-[#B92043] 
                    disabled:bg-[#ABB6AC] 
                    rounded-lg px-6 py-3 text-white text-sm font-medium hover:bg-[#B92043] transition-all"
          >
            {debitFarmerLoading ? "Processing..." : "Debit"}
          </button>
          <button
            onClick={() => {
              setShowConfirm(false);
              setShow(true);
            }}
            type="button"
            className="bg-transparent
                    rounded-lg px-6 py-3 text-[#5C715E] text-sm font-medium transition-all"
          >
            Cancel
          </button>
        </div>
      </ModalComponent>
    </div>
  );
};

export default DebitSingleFarmerModal;
